import React, { useContext, useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';

import CompanyInformation from 'components/intermediaryApplications/CompanyProfile/CompanyInformation/CompanyInformation';
import { RootStoreContext } from 'index';
import Spinner from 'components/common/Spinner/Spinner';
import AddressInformation from 'components/intermediaryApplications/CompanyProfile/AddressInformation/AddressInformation';
import UsersManagement from 'components/users/UsersManagement/UsersManagement';

import styles from './CompanyProfile.module.scss';

function CompanyProfile() {
  const { intermediaryApplicationsStore } = useContext(RootStoreContext);
  const [isCompanyProfileLoading, setIsCompanyProfileLoading] = useState(true);

  const getInitialData = async () => {
    setIsCompanyProfileLoading(true);

    try {
      await intermediaryApplicationsStore.getCompanyProfile();
    } finally {
      setIsCompanyProfileLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  if (isCompanyProfileLoading) {
    return <Spinner />;
  }

  return (
    <div className={styles.infoContainer}>
      <div className={styles.mainHeader}>Company Profile</div>
      <CompanyInformation />
      <AddressInformation />
      <div className={styles.mainContainer}>
        <div className={styles.inputsContainer}>
          <UsersManagement />
        </div>
      </div>
    </div>
  );
}

export default observer(CompanyProfile);
